import { render } from "./FriendAssign.vue?vue&type=template&id=9623bd2c"
import script from "./FriendAssign.vue?vue&type=script&lang=js"
export * from "./FriendAssign.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__